import { create } from 'zustand';
import { Booking } from '../types/booking';

interface HandoverState {
  bookingToHandover: Booking | null;
  bookingIdToHandover: string | null;
  setBookingToHandover: (booking: Booking | null) => void;
  setBookingIdToHandover: (id: string | null) => void;
}

export const useHandoverStore = create<HandoverState>((set) => ({
  bookingToHandover: null,
  bookingIdToHandover: null,
  setBookingToHandover: (booking) => set({ bookingToHandover: booking, bookingIdToHandover: null }),
  setBookingIdToHandover: (id) => set({ bookingIdToHandover: id, bookingToHandover: null }),
}));
